import React from "react";
import SectionTitle from "./sectiontitle";
import SocialLinks from "./sociallinks";
import "../style/contact.less";

class Contact extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            submitDisabled: false
        };
    }
    render() {
        return (
            <section id="contact" className="container">
                <div className="section-title">
                    <SectionTitle title="Termine" />
                </div>
                <div className="row no-form">
                    <div className="col s12">
                        <h5 class="date-header">
                            Termine 2027
                        </h5>
                        <ul className="dates">
                            <li>vorherige Termine sind bereits <strong>ausgebucht</strong></li>
                            <li>Mittwoch, 07. April 2027, 18 Uhr</li>
                            <li><strong>Sonntag, 18. April 2027 10-15 Uhr <br /> YOGA Meets Wildkräuter, 89€, in Begleitung 79€/pers.</strong></li>
                            <li>Dienstag, 25. Mai 2027, 18 Uhr</li>
                            <li>Sonntag, 06. Juni 2027, 15 Uhr</li>
                            <li>Sonntag, 20. Juni 2027, 15 Uhr</li>
                            oder nach Vereinbarung
                            <li className="price">
                                <strong>49€ pro Person</strong>
                            </li>
                            <li>Dauer: ca. 3 Stunden</li>
                            <li>inkl. kleine Führung mit Sammlung,</li>
                            <li>Getränken, Speisen, gemeinsames Kochen, Infos</li>
                            <li className="price"><strong>auch als Gutschein erhältlich!</strong></li>
                        </ul>
                        <h6 className="social-header">Informationen unter:</h6>
                        <ul>
                            <li>
                                <SocialLinks />
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        );
    }
}

export default Contact;
